// import './Splash.css';
import DemoGame from "./DemoGame";

function BattledriftDemo() {

  return (
    <div style={{height: '100%', minHeight: '700px'}} className="main-content-box demo-page athabasca">
      <DemoGame />
    </div>
  );
}

export default BattledriftDemo;
